import React, { useState, useEffect } from 'react';
import logo from '../Images/tas_logo.png';
import smileyE from '../Images/Elite_smiley.jpeg';
import smiley1 from '../Images/Smiley_figurer/150/Sm1bg.jpg';
import smiley2 from '../Images/Smiley_figurer/150/Sm3bg.jpg';
import smiley3 from '../Images/Smiley_figurer/150/Sm4bg.jpg';

export default function Footer({ score, reportLink }) {
  const [rating, setRating] = useState({ score: null, reportLink: '' });

  useEffect(() => {
    setRating({ score: score ?? null, reportLink: reportLink || '' });
  }, [score, reportLink]);

  const getSmileySrc = () => {
    switch (rating.score) {
      case 0: return smileyE;
      case 1: return smiley1;
      case 2: return smiley2;
      case 3: return smiley3;
      default: return null;
    }
  };
  const smileySrc = getSmileySrc();
  const year = new Date().getFullYear();

  if (!rating.reportLink) return null;

  const css = `
    .footer {
      background-color: #f0f0f0;
      border-top: 1px solid #ddd;
      padding: 24px 0;
      font-family: sans-serif;
    }
    .footer-container {
      max-width: 960px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .smiley-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
      margin-bottom: 24px;
    }
    .smiley-icon {
      width: 40px;
      height: 40px;
    }
    .smiley-text {
      margin-top: 6px;
      font-size: 16px;
      color: #0066cc;
    }
    .smiley-text:hover {
      text-decoration: underline;
    }
    .company-info {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .company-logo {
      width: 100px;
      height: auto;     /* preserve aspect ratio */
    }
    .company-text {
      margin-top: 8px;
      font-size: 14px;
      color: #555;
    }
    @media (min-width: 768px) {
      .footer-container {
        flex-direction: row;
        justify-content: space-between;
      }
      .smiley-link {
        margin-bottom: 0;
      }
      .smiley-icon {
        width: 48px;
        height: 48px;
      }
      .company-info {
        align-items: flex-end;
      }
    }
  `;

  return (
    <>
      <style>{css}</style>
      <footer className="footer">
        <div className="footer-container">
          <a
            href={rating.reportLink}
            target="_blank"
            rel="noopener noreferrer"
            className="smiley-link"
          >
            {smileySrc && (
              <img
                src={smileySrc}
                alt={`Smiley niveau ${rating.score === 0 ? 'elite' : rating.score}`}
                className="smiley-icon"
              />
            )}
            <span className="smiley-text">Se smiley rapport</span>
          </a>
          <div className="company-info">
            <img
              src={logo}
              alt="Take Away Systems logo"
              className="company-logo"
            />
            <span className="company-text">
              &copy; {year} Take Away Systems
            </span>
          </div>
        </div>
      </footer>
    </>
  );
}
